import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom"


// pages and components
import Home from './pages/Home'
import MyAccount from './pages/MyAccount'
import MyBag from './pages/MyBag'
import Product from './pages/Product'
import Collections from './pages/Collections'
import SignUp from './pages/SignUp'
import Login from './pages/Login'
import MyOrders from "./pages/MyOrders";
import Saved from "./pages/Saved";
import AboutUs from './pages/AboutUs'
import ContactUs from './pages/ContactUs'
import Sidebar from './components/Sidebar'
import { useAuthContext } from "./hooks/useAuthContext";
import { useLogout } from "./hooks/useLogout"
import Header from "./components/Header";
import AdminManagement from "./components/AdminManagement"
import ResetPassword from "./pages/ResetPassword";
import { ProtectedRoute } from './components/ProtectedRoute'; // Assuming you'll place ProtectedRoute in components folder

function App() {
  const { authIsReady } = useAuthContext();
  const { logout } = useLogout();
  const [isOpen, setIsOpen] = useState(false);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div>
      {authIsReady && (
        <BrowserRouter>
          {/* Sidebar */}
          <Sidebar isOpen={isOpen} toggle={toggleSidebar} />
          <Header toggleSidebar={toggleSidebar} isSidebarOpen={isOpen} logout={logout} />
          
          <main>
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<Home />} />
              <Route path="about" element={<AboutUs />} />
              <Route path="contact" element={<ContactUs />} />
              <Route path="/collections/:collectionId" element={<Collections />} />
              <Route path="/product/:productId" element={<Product />} />
              
              {/* Authentication Routes */}
              <Route 
                path="signup" 
                element={
                  <ProtectedRoute requireAuth={false}>
                    <SignUp />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="login" 
                element={
                  <ProtectedRoute requireAuth={false}>
                    <Login />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="reset-password" 
                element={
                  <ProtectedRoute requireAuth={false}>
                    <ResetPassword />
                  </ProtectedRoute>
                } 
              />

              {/* Protected Routes (Require Authentication) */}
              <Route 
                path="myaccount" 
                element={
                  <ProtectedRoute requireAuth={true}>
                    <MyAccount />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="mybag" 
                element={
                  <ProtectedRoute requireAuth={true}>
                    <MyBag />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="myorders" 
                element={
                  <ProtectedRoute requireAuth={true}>
                    <MyOrders />
                  </ProtectedRoute>
                } 
              />
                <Route 
                path="saved-items" 
                element={
                  <ProtectedRoute requireAuth={true}>
                    <Saved />
                  </ProtectedRoute>
                } 
              />

              {/* Admin-Only Routes */}
              <Route 
                path="adminmanagement" 
                element={
                  <ProtectedRoute adminOnly={true}>
                    <AdminManagement />
                  </ProtectedRoute>
                } 
              />
            </Routes>
          </main>
        </BrowserRouter>
      )}
    </div>
  );
}

export default App;